import { useGameSelector } from '../../GameStore';
import { HashModalDataType } from './slice';

export const useRecentResultDetailStateSlice = {
  getModalOpenStatus: (): boolean => {
    return useGameSelector(({ recentResultDetailState }) => recentResultDetailState.isOpen);
  },
  getTimeRemaining: (): number => {
    return useGameSelector(({ recentResultDetailState }) => recentResultDetailState.timeRemaining);
  },
  getInPlayHash: (): string => {
    return useGameSelector(({ recentResultDetailState }) => recentResultDetailState.inPlayHash);
  },
  getCopied: (): number => {
    return useGameSelector(({ recentResultDetailState }) => recentResultDetailState.copied);
  },
  getTimeStamp: (): string => {
    return useGameSelector(({ recentResultDetailState }) => recentResultDetailState.timeStamp);
  },
  getResultMultiplier: (): number => {
    return useGameSelector(({ recentResultDetailState }) => recentResultDetailState.resultMul);
  },
  getHashKey: (): string => {
    return useGameSelector(({ recentResultDetailState }) => recentResultDetailState.hashKey);
  },
  getHashResult: (): string => {
    return useGameSelector(({ recentResultDetailState }) => recentResultDetailState.hashResult);
  },
  getHashModalData: (): HashModalDataType => {
    return useGameSelector(({ recentResultDetailState }) => recentResultDetailState.hashModalData);
  }
};
